
import { Component, Prop, Vue, Watch } from 'nuxt-property-decorator';
import { SanityDocumentSchema } from '~/types/sanity-documents';
import LargeCTABackgroundPanel from '~/components/UIComponents/LargeCTABackgroundPanel.vue';

const schema = SanityDocumentSchema.PROJECT;

@Component({
  components: {
    LargeCTABackgroundPanel,
  },
})
export default class ProjectMBPromoPanel extends Vue {
  @Prop(String) readonly projectRef!: string;

  @Watch('posterImage')
  onDependentDataChange() {
    this.$forceUpdate();
  }
  private breakpoints: { [key: string]: number } = {
    sm: 600,
    md: 960,
    lg: 1264,
    xl: 1904,
  };

  async fetch() {
    await this.$sanityLookup.fetchDocument({
      _type: schema,
      _id: this.projectRef,
      fetchReferences: true,
    });
  }

  get pageState() {
    return (
      this.$sanityLookup.getDocumentFromId({
        _type: schema,
        _id: this.projectRef,
      }) || {
        isLoading: false,
        hasError: false,
      }
    );
  }

  get project() {
    return this.pageState?.data;
  }

  get isLoading() {
    return this.pageState?.isLoading;
  }

  get hasError() {
    return this.pageState?.hasError;
  }

  get posterImage() {
    if (!this.project?.pageHeroImage) {
      return;
    }
    return this.project?.pageHeroImage;
  }

  get projectSlug() {
    return this.project?.slug;
  }

  get logo() {
    if (!this.project?.logo) {
      return;
    }
    return this.$sanityImage.urlFor(this.project.logo).url();
  }

  get title() {
    return this.project?.title || '';
  }

  get mbImages() {
    if (this.posterImage) {
      return {
        sm: this.generateImagesSizes('sm') || '',
        md: this.generateImagesSizes('md') || '',
        lg: this.generateImagesSizes('lg') || '',
        xl: this.generateImagesSizes('xl') || '',
      };
    }
    return {
      sm: '',
      md: '',
      lg: '',
      xl: '',
    };
  }

  generateImagesSizes(vp: string) {
    const w = this.breakpoints[vp];
    const h = Math.round(w * (9 / 16));
    return this.$sanityImage
      .urlFor(this.posterImage)
      .width(w)
      .height(h)
      .fit('crop')
      .url();
  }
}
